module.exports = __webpack_public_path__ + "static/img/head_2.bc645c61.png";